
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushirenearmepune() {



    const cardData =
    {
        keyword: 'Bus Hire Near me Pune',
        heading: 'Amruta Travels: Bus Hire Near me Pune',
        headingDescription: 'Amruta Travels offers Bus Hire Near Me Pune, providing convenient and reliable transportation solutions for all your local and outstation travel needs. Whether you are organizing a family function, corporate event, school trip, or pilgrimage, our fleet of well-maintained buses ensures a comfortable and safe journey. Choose from a variety of seating options, including 17-seater, 32-seater, 40-seater, and 50-seater buses, tailored to accommodate groups of all sizes. With experienced drivers, punctual service, competitive pricing, and 24/7 customer support, Amruta Travels makes your travel experience in and around Pune seamless and stress-free. Book your bus today and travel with confidence!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Bus Hire on Rent in Katraj Pune",
      "description": "Amruta Travels provides reliable bus rental services in Katraj, Pune, offering a variety of buses for local and outstation trips. Our fleet includes AC and Non-AC options with professional drivers ensuring a comfortable journey."
    },
    {
      "name": "Bus On Rent in Koregaon Park Pune",
      "description": "Explore Koregaon Park and surrounding areas with Amruta Travels' bus rental services. Whether for corporate events, family trips, or city tours, our buses offer convenience and comfort, with various sizes and amenities available."
    },
    {
      "name": "Bus On Rent in Pimple Gurav Pune",
      "description": "Amruta Travels offers dependable bus rentals in Pimple Gurav, Pune, catering to group tours, corporate travel, and more. Choose from AC or Non-AC buses for a comfortable and hassle-free experience."
    },
    {
      "name": "35, 36, 40, 50 Seater Bus Rental in Pimpri",
      "description": "Choose from a wide range of buses including 35, 36, 40, and 50-seaters for group travel in Pimpri, Pune. Our buses are well-maintained, comfortable, and equipped with modern amenities for a smooth ride."
    },
    {
      "name": "Bus On Rent in Hadapsar",
      "description": "Rent a bus in Hadapsar with Amruta Travels for all your transportation needs. We provide buses in various capacities for group outings, school trips, corporate events, and more."
    },
    {
      "name": "Bus on Rent in Wagholi",
      "description": "Amruta Travels offers bus rentals in Wagholi, Pune, with a variety of options to choose from. Whether it's a corporate event or a family outing, our buses ensure comfort and safety."
    },
    {
      "name": "Hire Bus on Rent in Pune Airport",
      "description": "Book a bus for pick-up and drop services to and from Pune Airport. Amruta Travels offers buses in multiple sizes, ensuring timely and comfortable transportation for your airport journey."
    },
    {
      "name": "Bus On Rent in Lohegaon Pune",
      "description": "Amruta Travels provides reliable bus rentals in Lohegaon, Pune, ideal for group travel, events, or religious trips. Enjoy a safe and comfortable ride with experienced drivers."
    },
    {
      "name": "AC Bus On Rent in Wanowrie Pune",
      "description": "Enjoy the luxury and comfort of an AC bus on rent in Wanowrie, Pune. Amruta Travels offers a range of options for group travel, family outings, and corporate events."
    },
    {
      "name": "Bus Hire in Hinjewadi IT Park",
      "description": "For corporate events or group outings in Hinjewadi IT Park, Amruta Travels offers bus hire services with flexible seating arrangements and modern amenities to suit business needs."
    },
    {
      "name": "AC Bus On Rent in Kothrud Pune",
      "description": "Rent an AC bus in Kothrud, Pune, for all your travel needs, from educational tours to corporate trips. Amruta Travels provides comfortable and affordable transportation with a focus on safety and reliability."
    },
    {
      "name": "Tempo Traveller on Rent Near Me",
      "description": "Looking for a Tempo Traveller near you? Amruta Travels offers Tempo Traveller rentals in various sizes for small to medium-sized groups, ensuring comfort and convenience during your travels."
    },
    {
      "name": "17 Seater Bus on Rent Near Me Pune",
      "description": "Rent a 17-seater bus in Pune with Amruta Travels for group trips, family getaways, or corporate events. Our buses are well-maintained, and we provide flexible booking options for your convenience."
    }
  ],
  "tableData": [
    ["Bus Hire on Rent in Katraj Pune", "Bus On Rent in Koregaon Park Pune"],
    ["Bus On Rent in Pimple Gurav Pune", "35, 36, 40, 50 Seater Bus Rental in Pimpri"],
    ["Bus On Rent in Hadapsar", "Bus on Rent in Wagholi"],
    ["Hire Bus on Rent in Pune Airport", "Bus On Rent in Lohegaon Pune"],
    ["AC Bus On Rent in Wanowrie Pune", "Bus Hire in Hinjewadi IT Park"],
    ["AC Bus On Rent in Kothrud Pune", "Tempo Traveller on Rent Near Me"],
    ["17 Seater Bus on Rent Near Me Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Convenient Bus Hire Service Close to You",
    "WhyChoosedescription": "Amruta Travels offers a reliable and convenient bus hire service near you in Pune. Whether you need a bus for a local outing, corporate trip, or family event, we ensure that our buses are easily accessible and ready to meet your transportation needs. With a focus on punctuality and comfort, our services are designed to make your travel hassle-free, right from the moment you book until you reach your destination."
  },
  {
    "WhyChooseheading": "Ideal for Group Travel, Events, and Tours",
    "WhyChoosedescription": "Whether you're planning a school trip, corporate event, wedding, or group sightseeing tour, our **Bus Hire Near Me Pune** service is perfect for all types of travel. We offer buses of varying capacities, ensuring that your group can travel together in comfort. With air-conditioned seating and spacious interiors, we make sure that your entire group enjoys a relaxed and enjoyable journey."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers for a Safe Journey",
    "WhyChoosedescription": "Your safety is our priority. Our professional and experienced drivers are familiar with all routes in and around Pune, ensuring that you reach your destination safely and on time. They are well-trained in road safety, follow punctuality standards, and provide a courteous service, making your trip enjoyable and stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Local Bus Hire",
    "WhyChoosedescription": "At Amruta Travels, we provide competitive pricing for **Bus Hire Near Me Pune**, with no hidden charges. Our pricing is transparent, so you know exactly what you’re paying for. Whether you need a bus for a short local trip or a longer journey, we ensure that you get great value for your money with reliable and comfortable service."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for Every Journey",
    "WhyChoosedescription": "We maintain our fleet of buses to the highest standards of hygiene and safety. Each bus is regularly cleaned and serviced, ensuring that you travel in a clean and well-maintained environment. Whether it’s a short trip or a day-long outing, our buses provide the comfort you need for a smooth and pleasant ride."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "With our **Bus Hire Near Me Pune** service, we provide flexible pickup and drop-off options throughout the city. No matter where you’re located, we can arrange to pick you up and drop you off at your preferred locations, making your travel more convenient. Whether you need us to pick you up from home, office, or any specific point, we’ll ensure that the service fits your schedule and needs."
  },
  {
    "WhyChooseheading": "Customizable Travel Itineraries to Fit Your Needs",
    "WhyChoosedescription": "We understand that each trip has its own requirements, and that's why we offer customizable itineraries for all types of trips in Pune. Whether you're planning a tour around the city, a corporate event, or a family outing, we can tailor the journey to suit your group's specific needs. Our team works closely with you to design the perfect itinerary, ensuring a smooth and flexible travel experience."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking with Customer Support",
    "WhyChoosedescription": "Booking your **Bus Hire Near Me Pune** service with Amruta Travels is fast and easy. You can quickly book online, reach out to our customer support team for assistance, or visit our office in person. Our team is available to help you with any questions, provide travel advice, and ensure your booking is smooth and straightforward from start to finish."
  }
]















    }

const faqData = [
  {
    question: 'How can I hire a bus near me in Pune?',
    answer: 'Hiring a bus near you in Pune with Amruta Travels is simple. You can book online, contact our support team, or visit our office to discuss your travel requirements. We offer a range of buses for local, outstation, and corporate travel in and around Pune.',
  },
  {
    question: 'What types of buses are available for hire in Pune?',
    answer: 'We offer a wide range of buses for hire in Pune, including 32, 35, 45, and 50-seater options. Whether you need a standard, luxury, or AC bus, we have a vehicle to suit your needs.',
  },
  {
    question: 'Can I hire a bus for local travel near me in Pune?',
    answer: 'Yes, we offer bus rentals for local travel within Pune. Whether it’s for sightseeing, corporate events, school trips, or family outings, we’ll provide a bus that fits your needs and group size.',
  },
  {
    question: 'How much does it cost to hire a bus near me in Pune?',
    answer: 'The cost of hiring a bus depends on factors like bus size, duration, and the type of service you require. Contact us with your travel details for a personalized quote.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for bus hire near me in Pune?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Whether it’s a specific address in Pune or a nearby area, we’ll plan the best route to suit your needs.',
  },
  {
    question: 'Are the buses available for both short and long-distance travel?',
    answer: 'Yes, we provide buses for both short-distance local trips and long-distance outstation travel. Our buses are comfortable, well-maintained, and equipped with air conditioning and other amenities to ensure a smooth journey.',
  },
  {
    question: 'Do you provide luxury buses for hire near me in Pune?',
    answer: 'Yes, we offer luxury buses for hire near you in Pune. Our luxury buses come with premium seating, air conditioning, and entertainment options, ensuring a comfortable and upscale travel experience.',
  },
  {
    question: 'How soon can I book a bus near me in Pune?',
    answer: 'We offer flexible booking options. You can book a bus for immediate use or in advance, depending on availability. It’s best to book early for larger groups or during peak seasons.',
  },
  {
    question: 'Why should I choose Amruta Travels for bus hire near me in Pune?',
    answer: 'Amruta Travels is known for its reliable, professional, and punctual bus hire services. We offer well-maintained buses, experienced drivers, and a commitment to customer satisfaction. Whether for local or outstation trips, we ensure a seamless and comfortable travel experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Akash Nair',
    role: 'Corporate Client, Pune',
    text: 'I hired a 45-seater bus for a corporate event in Pune. The bus was in excellent condition, and the driver was professional and punctual. The whole process was smooth, and I will definitely consider Amruta Travels for future events!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Sinha',
    role: 'Family Trip Organizer, Pune',
    text: 'I rented a 35-seater bus for a family outing in Pune. The bus was spacious, clean, and comfortable. The driver ensured we had a pleasant and safe journey. Highly recommended for anyone looking for a reliable bus service near them!',
    rating: 5,
  },
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire Near Me in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-near-me-pune.jpg",
  "description": "Book local buses and Tempo Travellers on rent near you in Pune. Available in Katraj, Koregaon Park, Pimpri, Wagholi, Hadapsar, Lohegaon, Kothrud, Hinjewadi IT Park, and near Pune Airport. AC and non-AC 17 to 50 seater buses available for personal, group, and corporate travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6840"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3199",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-near-me-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Bus Hire Near Me in Pune | 17–50 Seater Bus Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Need a bus on rent near you in Pune? Book AC/non-AC buses and Tempo Travellers in Katraj, Koregaon Park, Pimpri, Wagholi, Hadapsar, Hinjewadi, Pune Airport, and more. 17 to 50 seater options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushirenearmepune;